<template>
	<div class="component admin-panel">
		<div class="fab" uk-toggle='target: #offcanvas-overlay-admin-panel' @click="toggleFab">
			{{ fabText }}
		</div>
		<div id="offcanvas-overlay-admin-panel" class="panel" uk-offcanvas="overlay: true">
			<div class="uk-offcanvas-bar">
				<button class="uk-offcanvas-close" type="button" uk-close></button>

				<h4>Quick links</h4>
				<div class="uk-grid">
					<div class="uk-width-1-2" v-show="cpEditUrl">	
						<a :href="cpEditUrl" target="_blank">
							<button class="uk-button uk-button-primary uk-button-small uk-width-1-1">Bewerken</button>
						</a>
					</div>
					<div class="uk-width-1-2" v-if="articleUrl">	
						<clipboard :text="articleUrl" button-text="Kopiëer link"></clipboard>
					</div>
					<div class="uk-width-1-2  uk-margin-small-top" v-show="bitlyApiKey">	
						<bitly-generator :long-url="articleUrl" :api-key="bitlyApiKey"></bitly-generator>
					</div>						
					<div v-show="articleAppUrl" class="uk-width-1-2  uk-margin-small-top">	
						<a :href="articleAppUrl" target="_blank">
							<button class="uk-button uk-button-secondary uk-button-small uk-width-1-1">App artikel</button>
						</a>
					</div>
					<div v-show="showCardsGenerator" class="uk-width-1-2  uk-margin-small-top">	
							<button uk-toggle="target: #cards-generator-modal" class="uk-button uk-button-secondary uk-button-small uk-width-1-1">Generator</button>
					</div>			
					<div class="uk-width-1-2  uk-margin-small-top">	
						<clipboard :text="articleUrl"  :open-link="true" link="https://search.google.com/u/2/search-console/inspect?resource_id=sc-domain%3Askoften.net" button-text="Google"></clipboard>
					</div>							
				</div>
				
				<div v-show="facebookPages" class="uk-margin-top">
					<h4>Facebook suite</h4>
					<div class="uk-grid uk-grid-small">
						<div v-for="(url, name) in facebookPages" :key="name" :href="url" class="uk-width-1-2">	
							<a :href="url" target="_blank">
								<button class="uk-button uk-button-primary uk-button-small facebook uk-width-1-1">{{ name }}</button>
							</a>
						</div>
					</div>
				</div>
				
				<h4>Cards</h4>
				<div class="uk-grid uk-grid-small">
					<div class="uk-width-1-3">	
						Story<br />	
						<card-generator 
							:id="entryId"
							:platform-type="cardsPlatformType"
							:generated-card="generatedStoryCard"
							:templates="storyCardTemplates"
							:image-url="socialCard"
							button-text="Genereren"
							:download-to-server="true" 
							cards-url="{{ cardsUrl }}"
							:hide-form-fields="true"
							:text-element-values="[
								{ element: 'title', type: 'text', value: entryTitle },
								{ element: 'caption', type: 'textarea', value: entryCaption },
							]"
						>
						</card-generator>
					</div>
												
					<div class="uk-width-1-3" v-show="generatedSocialCard">
						
						<div class="uk-margin-to">
							Social card<br />									
							<card-generator 
								:id="entryId"
								:platform-type="cardsPlatformType"
								:generated-card="generatedSocialCard"
								:templates="socialCardTemplates"
								:image-url="socialCard"
								button-text="Genereren"
								:download-to-server="true" 
								cards-url="{{ cardsUrl }}"
								:hide-form-fields="true"
								:text-element-values="[
									{ element: 'title', type: 'text', value: entryTitle },
									{ element: 'caption', type: 'textarea', value: entryCaption },
								]"
							>
							</card-generator>
							
						</div>
					</div>

					<div class="uk-width-1-3">
							
						Circle teaser<br />									
						<card-generator 
							:id="entryId"
							:platform-type="cardsPlatformType"
							:generated-card="generatedSocialTeaserCard"
							:templates="socialTeaserCardTemplates"
							:image-url="socialCard"
							:image-teaser-url="socialTeaserCard"
							button-text="Genereren"
							:download-to-server="true" 
							cards-url="{{ cardsUrl }}"
							:hide-form-fields="true"
							:text-element-values="[
								{ element: 'title', type: 'text', value: entryTitle },
								{ element: 'caption', type: 'textarea', value: entryCaption },
							]"
						>
						</card-generator>
					</div>

					<div class="uk-width-1-3 uk-margin-top">
						Video Story (9:16)<br />	
						<card-generator 
							:id="entryId"
							:platform-type="cardsPlatformType"
							:generated-video="generatedVideoStoryCard"
							:templates="videoStoryCardTemplates"
							:video-url="socialVideo"
							button-text="Genereren"
							image-file-type="mp4"
							:download-to-server="true" 
							cards-url="{{ cardsUrl }}"
							:hide-form-fields="true"
							:text-element-values="[
								{ element: 'title', type: 'text', value: entryTitle },
								{ element: 'call_to_action_text', type: 'textarea', value: 'SWIPE UP VOOR DE HELE VIDEO' },
							]"
						>
						</card-generator>
					</div>
					
					<div class="uk-width-1-3 uk-margin-top">
						Video Card (4:5)<br />	
						<card-generator 
							:id="entryId"
							:platform-type="cardsPlatformType"
							:generated-video="generatedVideoCard"
							:templates="videoCardTemplates"
							:image-url="socialCard"
							:video-url="socialVideo"
							image-file-type="mp4"
							button-text="Genereren"
							:download-to-server="true" 
							:cards-url="cardsUrl"
							:hide-form-fields="true"
							:text-element-values="[
								{ element: 'title', type: 'text', value: entryTitle },
								{ element: 'call_to_action_text', type: 'textarea', value: '👉 Meer via link in omschrijving' },
							]"
						>
						</card-generator>
					</div>
					
					<div class="uk-width-1-3 uk-margin-top">
						Video Reel (9:16)<br />	
						<card-generator 
							:id="entryId"
							:platform-type="cardsPlatformType"
							:generated-video="generatedReelCard"
							:templates="reelCardTemplates"
							:image-url="socialCard"
							:video-url="socialVideo"
							image-file-type="mp4"
							button-text="Genereren"
							:download-to-server="true" 
							:cards-url="cardsUrl"
							:hide-form-fields="true"
							:text-element-values="[
								{ element: 'title', type: 'text', value: entryTitle },
								{ element: 'call_to_action_text', type: 'textarea', value: 'Check de link in de omschrijving' },
							]"
						>
						</card-generator>
					</div>

				</div>
					
			</div>
		</div>
	</div>
</template>

<script>
import Clipboard from './Clipboard.vue'
import CardGenerator from './CardGenerator.vue'
import BitlyGenerator from './BitlyGenerator.vue'

export default {
	components: { Clipboard, CardGenerator, BitlyGenerator },
    props: {
		entryId: {
			type: Number,
		},
		entryTitle: {
			type: String,
		},
		entryCaption: {
			type: String,
		},
		entryImage: {
			type: String,
		},		
		cpEditUrl: {
			type: String,
			required: false
		},
		baseCpUrl: {
			type: String,
		},
		contentUrl: {
			type: String,	
		},
		cardsUrl: {
			type: String,	
		},
		cardsPlatformType: {
			type: String,
			required: true
		},
		socialCard: {
			type: String,
		},	
		socialVideo: {
			type: String,
		},
		socialTeaserCard: {
			type: String,
		},				
		socialCardTemplates: {
			type: Array,
		},
		socialTeaserCardTemplates: {
			type: Array,
		},		
		storyCardTemplates: {
			type: Array,
		},
		linkInCommentsCardTemplates: {
			type: Array,
		},
		videoStoryCardTemplates: {
			type: Array,		
		},
		videoCardTemplates: {
			type: Array,		
		},
		reelCardTemplates: {
			type: Array,		
		},
		generatedSocialCard: {
			type: String,
			required: false
		},
		generatedSocialTeaserCard: {
			type: String,
			required: false
		},		
		generatedStoryCard: {
			type: String,
			required: false
		},	
		generatedLinkInCommentsCard: {
			type: String,
			required: false
		},	
		generatedVideoStoryCard: {
			type: String,
			required: false
		},	
		generatedVideoCard: {
			type: String,
			required: false
		},	
		generatedReelCard: {
			type: String,
			required: false
		},						
		articleUrl: {
			type: String,
			required: false
		},
		articleAppUrl: {
			type: String,
			required: false
		},		
		facebookPages: {
			type: Object,
			required: false
		},	
		bitlyApiKey: {
			type: String,
			required: false
		},
		showCardsGenerator: {
			type: Boolean,
			default: false
		}
  },
	data() {
		return {
			status: 'closed',
			fabText: '+',
			defaultImage: `data:image/svg+xml;base64,${btoa(`
				<svg xmlns="http://www.w3.org/2000/svg" width="200" height="300">
				  <rect width="200" height="300" fill="#cccccc"/>
				  <text x="50%" y="50%" font-size="20" fill="#333" text-anchor="middle" dy=".3em">no card found</text>
				</svg>
			  `.trim())}`,
		}
	},
	mounted() {
		this.$logger('app/components/admin-panel/mounted');
	},
  computed: {
	},
  methods: {
		noImageFound(e) {
			this.$logger('app/components/admin-panel/setDefaultCard');
			e.target.src = this.defaultImage;
		},			
		toggleFab() {
			var component = this;
			component.status = (component.status == 'closed') ? 'open' : 'closed';
		},
		noImageFound(e) {
			this.$logger('app/components/admin-panel/setDefaultCard');
			e.target.src = this.defaultImage;
		},
		generateStoryCard() {
			alert('wordt aan gewerkt')
		}
  }
}
</script>

<style scoped>
#offcanvas-overlay-admin-panel .uk-offcanvas-bar {

}

@media only screen and (max-width: 640px) {
	#offcanvas-overlay-admin-panel .uk-offcanvas-bar {
		max-width: 100%;
		min-width: 100%;
	}
}

.component.admin-panel {
	z-index: 999999;
	position: relative;
}
.component.admin-panel .fab {
	width: 40px;
	height: 40px;
	background-color: var(--tint-color);
	border-radius: 50%;
	transition: all 0.1s ease-in-out;

	font-size: 24px;
	color: white;
	text-align: center;
	line-height: 40px;

	position: fixed;
	left: 30px;
	bottom: 80px;
	
	cursor: pointer;
}
.component.admin-panel .fab:hover {
	box-shadow: 0 6px 14px 0 #666;
	transform: scale(1.05);
}
</style>